const LocalStorage = {
    get: (name: string, returnDefault?: string | number | unknown) => {
        if (!name?.length) {
            throw new Error('Invalid key.');
        }

        if (typeof window === 'undefined') {
            return;
        }

        if (!window.localStorage) {
            console.log('[ERROR] LocalStorage is not avail.');
            return false;
        }

        const value = window.localStorage.getItem(name);
        try {
            if (value) {
                const parsed = JSON.parse(value);
                if (parsed) {
                    return parsed;
                }
            }
        } catch (e) {
            console.log(e);
        }

        return returnDefault;
    },
    set: (name: string, data?: string | number | unknown): boolean | void => {
        if (!name?.length) {
            throw new Error('Invalid key.');
        }

        if (!window.localStorage) {
            console.log('[ERROR] LocalStorage is not avail.');
            return false;
        }

        if (!data) {
            return false;
        }
        window.localStorage.setItem(name, JSON.stringify(data));
        return true;
    },
    remove: (name: string) => window.localStorage?.removeItem(name),
    clear: () => window.localStorage?.clear(),
};

const getStorage = () => {
    return LocalStorage;
};

export const getLS = (name: string, returnDefault?: string | number | unknown) =>
    getStorage().get(name, returnDefault);

export const setLS = (name: string, data?: string | number | unknown) =>
    getStorage().set(name, data);
export const removeLS = (name: string) => getStorage().remove(name);
export const clearLS = () => getStorage().clear();

export const setLSwithTime = (
    name: string,
    data: string | number | unknown,
    expireTimeSeconds: number
) => {
    setLS(name, {
        data,
        expireTime: new Date().getTime() + expireTimeSeconds * 1000,
    });
};

export const getLSwithTime = (name: string) => {
    const dataLS = getLS(name);

    if (dataLS?.expireTime && dataLS.expireTime > new Date().getTime()) {
        return dataLS.data;
    }

    if (dataLS) {
        removeLS(name);
    }

    return undefined;
};
